export const assetsPath = "assets/";
var imgsPath = assetsPath + "img/";
export const audioPath = assetsPath + "audio/";

export var to_load_json_atlas = {
    "reels_atlas": [imgsPath + "reels/reels_atlas_{q}.png", imgsPath + "reels/reels_atlas_{q}.json"],

    "lines_info_atlas": [imgsPath + "reels/lines_info_atlas_{q}.png", imgsPath + "reels/lines_info_atlas_{q}.json"],

    "symbols_atlas": [imgsPath + "symbols/symbols_atlas_{q}.png", imgsPath + "symbols/symbols_atlas_{q}.json"],
    "symbols_blur_atlas": [imgsPath + "symbols/symbols_blur_atlas_{q}.png", imgsPath + "symbols/symbols_blur_atlas_{q}.json"],

    "particles_atlas": [imgsPath + "particles3_tp_{q}.png", imgsPath + "particles3_tp_{q}.json"],
    "winbg" : [imgsPath + "winbg_tp_{q}.png", imgsPath + "winbg_tp_{q}.json"],
    "coins_atlas": [imgsPath + "coins_tp_{q}.png", imgsPath + "coins_tp_{q}.json"],

    "bigwin_atlas": [imgsPath + "bigwin/bigwins3_tp_{q}.png", imgsPath + "bigwin/bigwins3_tp_{q}.json"],
    "bonus_atlas": [imgsPath + "bonus/bonus_atlas_{q}.png", imgsPath + "bonus/bonus_atlas_{q}.json"],
    "boomspins_atlas": [imgsPath + "bonus/boomspins_atlas_{q}.png", imgsPath + "bonus/boomspins_atlas_{q}.json"],

    "info_atlas": [imgsPath + "info/info_atlas_{q}.png", imgsPath + "info/info_atlas_{q}.json"],

    "wild_locked_atlas": [imgsPath + "symbols/symbol_Wild_locked2_tp_{q}.png", imgsPath + "symbols/symbol_Wild_locked2_tp_{q}.json"]

    //"symb": [imgsPath + "fire_rope_atlas_100.png", imgsPath + "fire_rope_atlas_100.json"],
};

export const to_load = {
    // 'coin_sprite'				: 'framework/assets/img/coin/coins_{q}.png',
    // 'win_font_bg'				: imgsPath + 'fonts/win_font_bg_{q}.png',

    "reels_background": imgsPath + "reels/background_{q}.png",
//	"reels_background_bonus": imgsPath + "reels/background_boom-spins_{q}.png",
//	"reels_cover": imgsPath + "reels/cover_{q}.png",

    "winline_0": imgsPath + "winlines/winline1_{q}.png",

    "info": imgsPath + "info/info_{q}.jpg",
    "wintable": imgsPath + "info/wintable_{q}.png",

    "wild_bg": imgsPath + "symbols/symbol_Wild_background_{q}.png"
};

var audioType = "ogg";

export const to_load_audio = {
    "audio_bonus_bg": audioPath + "bg_BoomSpins." + audioType,

    "audio_big_win_explosion": audioPath + "bwin_Explosion." + audioType,
    "audio_big_win": audioPath + "bwin_BigWin." + audioType,
    "audio_mega_win": audioPath + "bwin_SuperMegaWin_Start." + audioType,
    "audio_big_win_end": audioPath + "bwin_SuperMegaWin_End." + audioType,

    "reel_spin": audioPath + "reel_Spin." + audioType,
    "reel_stop": audioPath + "reel_Stop." + audioType,

    "win_low_1": audioPath + "win_Low_1." + audioType,
    "win_low_2": audioPath + "win_Low_2." + audioType,
    "win_low_3": audioPath + "win_Low_3." + audioType,
    "win_low_4": audioPath + "win_Low_4." + audioType,
    "win_high_1": audioPath + "win_High_1." + audioType,
    "win_high_2": audioPath + "win_High_2." + audioType,
    "win_high_3": audioPath + "win_High_3." + audioType,
    "win_high_4": audioPath + "win_High_4." + audioType,
    "win_stars": audioPath + "win_Stars." + audioType,

    "symbol_joker": audioPath + "symbol_Joker." + audioType,
    "symbol_star": audioPath + "symbol_Star." + audioType,

    "bonus_joker": audioPath + "bonus_Joker." + audioType,
    "bonus_start": audioPath + "bonus_Start_Whoosh." + audioType,
    "bonus_pick": audioPath + "bonus_Pick." + audioType,
    "bonus_end": audioPath + "bonus_Explo_Whoosh." + audioType,
	Jackpot_sound: assetsPath + "JokerWinBanner/Jackpot_sound.mp3",
	JokerBonus_alert: assetsPath + "JokerWinBanner/JokerBonus_alert.mp3",	
};

export const to_load_json = {
    'infotext' 				: assetsPath + "info/info_{l}.json"
};

export const to_load_fonts = {
    /*'win_font' :	{
        "img":	imgsPath + 'fonts/win_font.png',
        "xml":	imgsPath + 'fonts/win_font.xml'
    },*/

    "font_bigwins" : {
        'img':	imgsPath + 'fonts/font_bigwins.png',
        'xml':	imgsPath + 'fonts/font_bigwins.xml'
    },

    "font_bigwins_edited" : {
        'img':	imgsPath + 'fonts/font_bigwins_edited.png',
        'xml':	imgsPath + 'fonts/font_bigwins_edited.xml'
    },

    "font_bigwins_second_edited" : {
        'img':	imgsPath + 'fonts/font_bigwins_second.png',
        'xml':	imgsPath + 'fonts/font_bigwins_second_edited.xml'
    },

    "font_freespins" : {
        "img":	imgsPath + "fonts/font_freespins.png",
        "xml":	imgsPath + "fonts/font_freespins.xml"
    },

    "font_wintable" : {
        "img":	imgsPath + "fonts/font_wintable.png",
        "xml":	imgsPath + "fonts/font_wintable.xml"
    }
};

// var to_load_spritesheets = {
//     //"wild_random_shine_sheet": { "url": imgsPath + "symbols/wild/wild_random_appear_shine_sheet_{q}.png", "w": 207, "h": 207 }
// };

export function set_sounds() {
    
}